<template>
  <panel>
    <w-table
      v-if="count !== undefined"
      id-key="documentId"
      :data="list"
      :columns="columns"
      :total="count"
      :show-column-numbers="true"
      :hide-search-input="true"
      :hide-add-button="true"
      :per-page="-1"
      @view="goToDetails"
    />

    <div slot="footer" class="float-right">
      <div>
        <post-form
          text="Pobierz CSV"
          class="btn-light mr-2"
          icon="fas fa-download mr-2"
          :url="csvUrl"
          :fields="renderFields"
          :disabled="!count"
        />
      </div>
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import WTable from '@/components/table/Table';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { config } from '@/utils/config';

// @vuese
// Lista wszystkich dokumentów do raportów
// @group Reports
export default {
  components: { Panel, PostForm, WTable },

  data() {
    return {
      csvUrl: config.csvURL + '/financial-report'
    };
  },

  computed: {
    ...mapState({
      list: state => state.documentIndex.financialReport,
      columns: state => JSON.parse(state.setting.settings[PublicSettings.FINANCIAL_REPORT_COLUMNS].value),
      renderFields(state) {
        return [
          { name: 'procedureId', value: this.$route.params.procedureId },
          { name: 'structureIds', value: state.auth.nodes?.map(node => node.id) }
        ];
      }
    }),
    count() {
      return this.list.length;
    }
  },
  methods: {
    // @vuese
    // Przenosi do szczegółów wniosku
    goToDetails(document) {
      this.$router.push({
        name: 'documentView',
        params: { documentId: document.documentId, procedureId: document.procedureId }
      });
    }
  }
};
</script>
